var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRvoIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon rvo-icon",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0c10.493 0 19 8.507 19 19s-8.507 19-19 19S0 29.493 0 19 8.507 0 19 0zm12.707 7.707l-24 24A16.938 16.938 0 0019 36c9.389 0 17-7.611 17-17 0-4.335-1.622-8.29-4.293-11.293zM19 2C9.611 2 2 9.611 2 19c0 4.335 1.622 8.29 4.293 11.293l24-24A16.938 16.938 0 0019 2z"
  })));
}

export default SvgRvoIconSv;